import React from "react";
import "./index.scss";

const ShootingStars = () => {
  return (
    <div className="shooting-stars-container">
      {[...Array(10)].map((_, index) => {
        const randomDuration = Math.random() * 3 + 2;
        return (
          <span
            key={index}
            style={{
              animationDuration: `${randomDuration}s`,
            }}
          ></span>
        );
      })}
    </div>
  );
};

export default ShootingStars;
